import React from 'react';
import styled from 'styled-components';
import { HalfBanner } from '../components/Banners';
import { Title, Content } from '../components/Elements';
import Link from 'gatsby-link';
import MetaTags from '../components/MetaTags';

const StyledAbout = styled.div`
	.services-wrap {
		padding-bottom: 100px;
	}
`;

export default ({ data }) => (
	<StyledAbout>
		<MetaTags
			title="About | Wavey Media Group"
			description="We map the exhibition of brands before they need to
				take the next step."
		/>
		<HalfBanner title="About Us" image={data.topBanner} dark={true} />
		<Title title="We collaborate with companies to create and expand digital identities" />
		<Content>
			<p>
				We're witnessing a new age in technology, one simultaneously changing
				and inspired by new behaviors. Brands must be bolder than ever before.
				And when it comes to how they exhibit themselves, they must compete to
				stay interesting and relevant–meeting their audiences where they are and
				simultaneously creating and accessing new channels. That's why we're a
				new type of agency. We map the exhibition of brands before they need to
				take the next step. Because the nature of change, is in fact changing.
				And change is rapidly happening with all sorts of things. Things expire.
				We don't.
			</p>
		</Content>
		<div className="services-wrap">
			<Title title="Our Services" />
			<Content>
				<p>
					We specialize in creating unique Shopify and Wordpress builds using
					the latest web development tools. Many of our sites are built with
					GatsbyJS, a framework that makes them blazingly fast, and ideal for
					SEO (Search Engine Optimization). Some of our current builds can be
					seen <Link to="/work">here</Link>.
				</p>
			</Content>
		</div>
	</StyledAbout>
);

export const query = graphql`
	query AboutData {
		topBanner: imageSharp(id: { regex: "/nyc.jpeg/" }) {
			sizes(quality: 100, maxWidth: 2300) {
				...GatsbyImageSharpSizes
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/about.js